module.exports = __webpack_public_path__ + "static/media/cost-efficient.3cdf3700.jpg";